let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cnNml")).then(() => parcelRequire('aNYOV'));